import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { CommuterTrafficFeeType } from './commuter-traffic-fee-type.interface';

export class CommuterTrafficFeeTypeService {
   async getCommuterTrafficFeeTypes() {
      return await http
         .get<PaginatedResponse<CommuterTrafficFeeType>>(`/commuter-traffic-fee-types`, { ...cacheFirstConfig })
         .then((response) => response?.data?.data);
   }
}
